/**
 * Created by anatolij on 05.11.2026
 */

const findReadySuppliesSale = function () {
    return [Offers.TYPES.SUPPLIES_SALE, Offers.TYPES.CLSUPPLIES_SALE]
        .map((type) => cleverapps.offerManager.findOffer({ type }))
        .find((offer) => offer && offer.logic.isReady());
};

Placements.ENTRIES["suppliesSaleReward"] = {
    throttled: true,

    type: Placements.FREE_FOCUS_MAIN,

    action: function () {
        const offer = findReadySuppliesSale();
        if (offer) {
            cleverapps.offerManager.showOfferWindow(offer);
        }
    }
};
